import { render } from "./Column202309.vue?vue&type=template&id=265e97d9&scoped=true"
import script from "./Column202309.vue?vue&type=script&lang=js"
export * from "./Column202309.vue?vue&type=script&lang=js"

import "./Column202309.vue?vue&type=style&index=0&id=265e97d9&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-265e97d9"]])

export default __exports__